import PULSE_CONSTANTS from 'common/pulseConstants';

const { PULSE_ANONYMITY, PULSE_ANONYMITY_SHARE_OPTIONS } = PULSE_CONSTANTS;

const utils = {};

utils.PULSE_MIN_COMMENTS_LENGTH = 10;

utils.areCommentsValid = (comments) => Boolean(comments && comments.length >= utils.PULSE_MIN_COMMENTS_LENGTH);

utils.getAnonymous = (questionAnonymity, anonymousValue) => {
  if (questionAnonymity === PULSE_ANONYMITY.FORCE_ANONYMOUS) {
    return true;
  }
  if (questionAnonymity === PULSE_ANONYMITY.PREVENT_ANONYMOUS) {
    return false;
  }
  if (
    anonymousValue === PULSE_ANONYMITY_SHARE_OPTIONS.SHARE_ANONYMOUSLY.value
  ) {
    return true;
  }
  return false;
};

export default utils;
